(() => {
  const form = document.querySelector("#vc-order form");
  if (!form) return;

  const phone = form.elements.phone;
  const total = form.querySelector("[data-total]");
  const status = form.querySelector(".vc-status");
  const submit = form.querySelector("[type=submit]");
  const success = document.querySelector("#vc-order .vc-success");
  const emptyTotal = total.textContent;
  let pending = false;
  let completed = false;
  let responseId;

  function makeId() {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
    return [hex.slice(0,8), hex.slice(8,12), hex.slice(12,16), hex.slice(16,20), hex.slice(20)].join("-");
  }

  function normalizePhone(value) {
    const digits = value
      .replace(/[٠-٩]/g, digit => "٠١٢٣٤٥٦٧٨٩".indexOf(digit))
      .replace(/[۰-۹]/g, digit => "۰۱۲۳۴۵۶۷۸۹".indexOf(digit))
      .replace(/[\s().-]/g, "");
    const mobile = digits.match(/^(?:\+966|0)(5\d{8})$/);
    return mobile ? "+966" + mobile[1] : "";
  }

  function updateTotal() {
    const selected = form.querySelector("[name=offer]:checked");
    total.textContent = selected ? selected.dataset.price + " ريال" : emptyTotal;
  }

  form.addEventListener("change", updateTotal);
  phone.addEventListener("input", () => phone.setCustomValidity(""));
  form.addEventListener("submit", async event => {
    event.preventDefault();
    if (pending || completed || form.elements.website?.value) return;

    const mobile = normalizePhone(phone.value);
    if (!mobile) {
      phone.setCustomValidity("أدخل رقم جوال سعودي صحيح يبدأ بـ ⁦+966 5⁩ أو ⁦05⁩.");
      phone.reportValidity();
      return;
    }

    pending = true;
    submit.disabled = true;
    submit.textContent = "جارٍ إرسال الطلب…";
    status.textContent = "";

    try {
      responseId ||= makeId();
      const query = new URLSearchParams(location.search);
      const utm = key => (query.get("utm_" + key) || "").trim().slice(0, 120);
      const result = await fetch(form.action, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: responseId,
          phone: mobile,
          offer: new FormData(form).get("offer"),
          source: utm("source"),
          medium: utm("medium"),
          campaign: utm("campaign"),
          content: utm("content"),
        }),
        signal: AbortSignal.timeout(12000),
      });
      const saved = await result.json();
      if (!result.ok || saved.ok !== true) throw new Error("Order request failed");

      completed = true;
      const offer = new FormData(form).get("offer");
      try {
        const published = window.Shopify?.analytics?.publish("vivalle_saudi_lead", {
          event_id: responseId,
          offer,
          value: offer === "duo" ? 269 : 199,
          currency: "SAR",
        });
        Promise.resolve(published).catch(() => {});
      } catch {}
      form.reset();
      form.hidden = true;
      success.hidden = false;
      success.tabIndex = -1;
      success.focus();
    } catch {
      status.textContent = "تعذّر إرسال الطلب. حاول مرة ثانية.";
    } finally {
      pending = false;
      submit.disabled = completed;
      submit.textContent = "أرسل طلبي";
    }
  });
  updateTotal();
  submit.disabled = false;
})();
